"use client"

import { useEffect } from "react"
import {
  SIGNUP_ATTR_COOKIE,
  SIGNUP_ATTR_MAX_AGE_S,
  attributionFromVisit,
  decodeAttribution,
  encodeAttribution,
  nextAttribution,
  readCookie,
  withoutClickIds,
} from "@/lib/marketing/signupAttribution"
import { isOptedOutClient } from "@/lib/tracking/optOut"

/**
 * Guarda de dónde llegó el visitante (utm_* o el sitio que lo mandó) en una
 * cookie propia de useredy.com, para que el alta la lea aunque se registre
 * varias páginas después. Las reglas viven en lib/marketing/signupAttribution.
 * No pinta nada; si el navegador bloquea cookies, simplemente no se guarda.
 */
export function SignupAttributionCapture() {
  useEffect(() => {
    try {
      const stored = decodeAttribution(readCookie(document.cookie, SIGNUP_ATTR_COOKIE))
      const visit = attributionFromVisit({
        search: window.location.search,
        pathname: window.location.pathname,
        referrer: document.referrer,
        ownHost: window.location.hostname,
        now: new Date(),
      })
      let next = nextAttribution(stored, visit)
      // Con exclusión (GPC o «Your Privacy Choices») no se guardan los click-ids:
      // son lo que el alta sube a Meta/Google. Si ya había, se limpian.
      const optedOut = isOptedOutClient(document, navigator as { globalPrivacyControl?: boolean })
      if (optedOut) {
        const base = next ?? stored
        if (!base) return
        const stripped = withoutClickIds(base)
        if (!next && JSON.stringify(stripped) === JSON.stringify(base)) return
        next = stripped
      }
      if (!next) return
      const secure = window.location.protocol === "https:" ? "; Secure" : ""
      document.cookie = `${SIGNUP_ATTR_COOKIE}=${encodeAttribution(next)}; Path=/; Max-Age=${SIGNUP_ATTR_MAX_AGE_S}; SameSite=Lax${secure}`
    } catch {
      // Medición: nunca rompe la página.
    }
  }, [])
  return null
}
